<template>
  <base-nav class="navbar-top navbar-dark" id="navbar-main" :show-toggle-button="false" expand>
    <ul class="navbar-nav align-items-center navbar-expand d-md-flex mr-auto">
      <li class="nav-item dropdown">
        <base-dropdown class="nav-link pr-0">
          <div class="media align-items-center" slot="title">
            <div class="media-body text-right">
              <i class="fa fa-user fa-fw"></i> ¡Hola!
              <span class="mb-0 text-sm font-weight-bold">
                {{model.nombre}}
                <i class="fa fa-caret-down"></i>
              </span>
            </div>
          </div>
          <user-menu-items />
        </base-dropdown>
      </li>
    </ul>
    <ul class="navbar-nav align-items-center navbar-expand d-md-flex ml-auto">
      <li class="nav-item right">
        <!-- <base-dropdown class="nav-link pr-0">
                    <div class="media align-items-center" slot="title">
                        <div class="text-right">
                           <i class="fa fa-money-bill-alt fa-fw"></i> Su saldo es <b>$ </b>
                        </div>                       
                    </div>

                    <template>
                        <router-link to="/ctacte" class="dropdown-item">
                            <i class="fa fa-search"></i>
                            <span>Ver movimientos</span>
                        </router-link>
                    </template>
        </base-dropdown>-->

        <div class="text-right" style="font-weight:bold;color:White">{{$store.getters.cashBoxName}}</div>
      </li>
    </ul>
  </base-nav>
</template>

<script>
import UserMenuItems from "@/components/UserMenuItems";

export default {
  data() {
    return {
      model: {
        nombre: this.$store.getters.userName
      },
      activeNotifications: false,
      showMenu: false,
      searchQuery: ""
    };
  },
  components: {
    UserMenuItems
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    }
  }
};
</script>
